export class SwitchNews
{
    buttons = document.querySelectorAll('[data-s~="SwitchNews:trigger"]')
    subpageLink = document.querySelector('[data-s~="SwitchNews:subpageLink"]')
    newsTypeImgs = document.querySelectorAll('[data-s~="SwitchNews:img"]')

    check(e)
    {
        let uuid = e.getAttribute("data-uuid")
        let allButtons = document.querySelectorAll('[data-s~="SwitchNews:trigger"]')
        let allTargets = document.querySelectorAll('[data-s~="SwitchNews:target"]')
        let targets = document.querySelectorAll('[data-s~="SwitchNews:target"][data-uuid~="'+uuid+'"]')

        allButtons.forEach(e => {
            e.style.backgroundColor = "transparent"
		})
        e.style.backgroundColor = "#1B2833"

        allTargets.forEach(e => {
            e.style.display = "none"
		})
        targets.forEach(e => {
            e.style.display = "flex"
		})

        this.updateSubpageLink(uuid)
        this.showAllTypeImgs()
        this.hideUnnecessaryTypeImgs(uuid)
    }

    updateSubpageLink(type)
    {
        let defaultSubpageLink = this.subpageLink.dataset.defaultsubpagelink;
        let newSubpageLink = (type === 'all') ? defaultSubpageLink : defaultSubpageLink + '/' + type;
        this.subpageLink.href = newSubpageLink;
    }

    showAllTypeImgs()
    {
        this.newsTypeImgs.forEach((e) => {
            e.style.display = "block";
        });
    }

    hideUnnecessaryTypeImgs(type)
    {
        if (type !== 'all') {
            this.newsTypeImgs.forEach((e) => {
               if (type !== e.dataset.imgtypeslug) {
                   e.style.display = "none";
               }
            });
        }
    }

    watch()
    {
        this.buttons.forEach(e => {
            e.addEventListener("click", () => {
				this.check(e)
			})
		})
    }
}
